import { useParams, useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useState, useEffect } from "react";
import { fetchDossierById } from "../../../lib/api/resources/dossiers";
import { AgentDossierOverviewTab } from "./tabs/AgentDossierOverviewTab";
import { AgentDossierKnowledgeBaseTab } from "./tabs/AgentDossierKnowledgeBaseTab";
import { AgentDossierChatSessionsTab } from "./tabs/AgentDossierChatSessionsTab";
import { fetchAgentSessionByDossierId } from "../../../lib/api/resources/agent";
import { Tabs, TabsProps } from "@/components/v2";

export const AgentDossierDetail = () => {
  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState("overview");

  if (!id) return null;

  const dossierQuery = useQuery({
    queryKey: ["dossier", id],
    queryFn: () => fetchDossierById(id),
  });

  const dossierAgentSessionsQuery = useQuery({
    queryKey: ["dossierAgentSessions", id],
    queryFn: () => fetchAgentSessionByDossierId(id),
    select: (data) => {
      //TODO: Temp bug fix to remove duplicate sessions, remove when backend is fixed
      const uniqueSessions = data.agentSessions.filter(
        (session, index, self) =>
          index === self.findIndex((s) => s.id === session.id),
      );
      return {
        ...data,
        agentSessions: uniqueSessions,
      };
    },
  });

  const tabs: TabsProps["items"] = [
    {
      key: "overview",
      label: "Overzicht",
      children: (
        <AgentDossierOverviewTab
          data={dossierQuery.data}
          isLoading={dossierQuery.isFetching}
          setActiveTab={setActiveTab}
        />
      ),
    },
    ...(dossierQuery.data?.leaseCompany?.name === "Athlon"
      ? [
          {
            key: "knowledge-base",
            label: "Pet van Schadenet",
            children: <AgentDossierKnowledgeBaseTab />,
          },
        ]
      : []),
    ...(dossierAgentSessionsQuery.data?.agentSessions?.length &&
    dossierAgentSessionsQuery.data.agentSessions.length > 0
      ? [
          {
            key: "chat-sessions",
            label: "Chat Sessies",
            children: (
              <AgentDossierChatSessionsTab
                data={dossierAgentSessionsQuery.data}
                isLoading={dossierAgentSessionsQuery.isFetching}
              />
            ),
          },
        ]
      : []),
  ];

  useEffect(() => {
    const tabFromUrl = searchParams.get("activeTab");
    if (tabFromUrl) {
      const validTabKeys = tabs?.map((tab) => tab?.key).filter(Boolean);
      if (validTabKeys.includes(tabFromUrl)) {
        setActiveTab(tabFromUrl);
        searchParams.delete("activeTab");
        setSearchParams(searchParams, { replace: true });
      }
    }
  }, [tabs]);

  return <Tabs activeKey={activeTab} onChange={setActiveTab} items={tabs} />;
};
